/* ============================================================
   Футер витрины: фирменная рамочная панель, навигация, соцсети,
   подписка и отдельная нижняя служебная строка.
   ============================================================ */
import { useState } from 'react';
import { useFedStore, useL } from '../store';
import { useFedContent } from '../content';
import { SOCIALS } from '../data';
import { Ic } from '../icons';
import { FedLogo } from '../ui';

export default function FedFooter() {
  const { go, lang } = useFedStore();
  const L = useL();
  const tournaments = useFedContent((s) => s.tournaments);
  const settings = useFedContent((s) => s.settings);
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const activeTour = tournaments.find((t) => t.status === 'live') || tournaments.find((t) => t.status === 'soon');
  const goJoin = () => activeTour
    ? go('tournament', { tourId: activeTour.id, tourTab: 'reg' })
    : go('tournaments');

  const ru = lang !== 'kz';
  const columns = [
    {
      title: ru ? 'Навигация' : 'Навигация',
      links: [
        [ru ? 'Главная' : 'Басты бет', 'home'], [L.nav_tournaments, 'tournaments'],
        [L.nav_news, 'news'], [L.nav_live, 'live'], [L.nav_about, 'about'],
        [L.nav_regs, 'regulations'], [L.nav_partners, 'partners'], [L.nav_contacts, 'contacts'],
      ],
    },
    {
      title: ru ? 'Турниры' : 'Турнирлер',
      links: [
        [ru ? 'Все турниры' : 'Барлық турнирлер', 'tournaments'],
        [ru ? 'Календарь' : 'Күнтізбе', 'tournaments'],
        [ru ? 'Результаты' : 'Нәтижелер', 'winners'],
        [ru ? 'Команды' : 'Командалар', 'teams'],
        [ru ? 'Мои заявки' : 'Менің өтінімдерім', 'profile'],
      ],
    },
    {
      title: ru ? 'Поддержка' : 'Қолдау',
      links: [
        ['FAQ', 'contacts'], [ru ? 'Как участвовать' : 'Қалай қатысуға болады', 'tournaments'],
        [ru ? 'Правила турниров' : 'Турнир ережелері', 'regulations'],
        [ru ? 'Связаться с нами' : 'Бізбен байланысу', 'contacts'],
      ],
    },
  ];

  const subscribe = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubscribed(true);
  };

  return (
    <footer className="fed-footer relative">
      <div className="fed-footer-wrap max-w-[1720px] mx-auto px-5">
        <div
          className="fed-footer-main"
          style={{ backgroundImage: `linear-gradient(90deg,rgba(6,6,8,.12),rgba(6,6,8,.3)),url('${encodeURI('/assets/верхний.png?v=1')}')` }}
        >
          <div className="fed-footer-brand">
            <button onClick={() => go('home')} className="fed-footer-logo" aria-label={L.brandTop}>
              <FedLogo size={72} glow={false} />
              <span>
                <b>{settings.name || L.brandTop}</b>
                <small>{settings.region || L.brandSub}</small>
              </span>
            </button>
            <p>{settings.about || L.footAbout}</p>
            <div className="fed-footer-social-title">{ru ? 'Мы в социальных сетях' : 'Біз әлеуметтік желілердеміз'}</div>
            <div className="fed-footer-socials">
              {SOCIALS.map((s) => (
                <a key={s.name} href={s.href} target="_blank" rel="noopener noreferrer" title={s.name} aria-label={s.name}>
                  <Ic name={s.icon} size={21} />
                </a>
              ))}
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" title="Instagram" aria-label="Instagram">
                <Ic name="instagram" size={21} />
              </a>
            </div>
          </div>

          {columns.map((column) => (
            <nav key={column.title} className="fed-footer-column" aria-label={column.title}>
              <h3>{column.title}</h3>
              {column === columns[2] && <a href="https://wa.me/77787671112" target="_blank" rel="noopener noreferrer">WhatsApp: +7 778 767 1112</a>}
              {column.links.map(([label, route]) => (
                <button key={`${label}-${route}`} onClick={() => go(route)}>{label}</button>
              ))}
            </nav>
          ))}

          <div className="fed-footer-subscribe">
            <h3>{ru ? 'Будь в игре' : 'Ойыннан қалма'}</h3>
            <p>{ru ? 'Подпишись на новости и получай информацию о турнирах первым.' : 'Жаңалықтарға жазылып, турнирлер туралы ақпаратты бірінші ал.'}</p>
            {subscribed ? (
              <div className="fed-footer-subscribed"><Ic name="check" size={18} />{ru ? 'Вы подписаны' : 'Сіз жазылдыңыз'}</div>
            ) : (
              <form onSubmit={subscribe}>
                <label>
                  <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={ru ? 'Ваш e-mail' : 'E-mail мекенжайыңыз'} />
                  <Ic name="inbox" size={18} />
                </label>
                <button type="submit"><span>{ru ? 'Подписаться' : 'Жазылу'}</span><b>→</b></button>
              </form>
            )}
            <button onClick={goJoin} className="fed-footer-join-link">{ru ? 'Принять участие в турнире' : 'Турнирге қатысу'} →</button>
          </div>
        </div>

        <div
          className="fed-footer-bottom"
          style={{ backgroundImage: `url('${encodeURI('/assets/нижний.png?v=1')}')` }}
        >
          <div>
            <span>© 2026 {L.footCopy}</span>
            <span>{ru ? 'Все права защищены' : 'Барлық құқықтар қорғалған'}</span>
          </div>
          <div className="fed-footer-legal">
            <button onClick={() => go('privacy')}>{ru ? 'Политика конфиденциальности' : 'Құпиялық саясаты'}</button>
            <i />
            <button onClick={() => go('terms')}>{ru ? 'Пользовательское соглашение' : 'Пайдаланушы келісімі'}</button>
          </div>
          <button className="fed-footer-made" onClick={() => go('team')} aria-label={ru ? 'Перейти на страницу команды ITshechka' : 'ITshechka командасының бетіне өту'}>
            <span>Made by</span>
            <strong>ITshechka</strong>
          </button>
          <button className="fed-footer-up" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} aria-label={ru ? 'Наверх' : 'Жоғары'}>↑</button>
        </div>
      </div>
    </footer>
  );
}
